import React from "react";

import KPIComparison from "components/visuals/KPIComparison";
import useColourPalette from "components/visuals/useColourPalette";
import { Box, Typography } from "@material-ui/core";
import { useAppSelector } from "store";
import { selectIsLoading, selectHasErrors, selectLatestMonthFootfall } from "modules/customer/tools/location/footfallNew/footfallSlice";
import numberFormatter from "utils/numberFormatter";
import { selectComparatorsByChapter } from "modules/customer/tools/location/locationSlice";

const LatestMonthVisits: React.FC = () => {
    const colourPalette = useColourPalette();
    const comparators = useAppSelector(selectComparatorsByChapter);
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const latestMonthFootfall = useAppSelector(selectLatestMonthFootfall);
    const differencePositiveSign = latestMonthFootfall.numberOfVisits.percentageDifference > 0 ? "+" : "";

    const label = `
        Average visits per cell within the selected retail centre
        (${latestMonthFootfall.latestMonthDate.monthLong} ${latestMonthFootfall.latestMonthDate.year})
    `;
    return (
        <Box width="100%" height="100%" data-cy="average-visits-per-cell">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h3" component="div" style={{ color: colourPalette.comparators[0] }}>
                        {numberFormatter.toDecimalPlaces(latestMonthFootfall.numberOfVisits.selectedStore, 1)}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[1] }}>
                        {numberFormatter.toDecimalPlaces(latestMonthFootfall.numberOfVisits.comparator, 1)}
                    </Typography>
                }
                comparisonLabel={`Comparator: ${comparators?.footfall.storeName}`}
                differenceValue={
                    <Typography variant="h6" component="div" style={{ color: "#FFFFFF" }}>
                        {differencePositiveSign}{numberFormatter.toPercentage(latestMonthFootfall.numberOfVisits.percentageDifference)}
                    </Typography>
                }
                differenceLabel="Difference"
            />
        </Box>
    );
};

export default LatestMonthVisits;
